module.exports = __webpack_public_path__ + "img/bg5.56bea3eb.png";